import Image from 'next/image';

interface Props {
  alt: string;
  sizes?: string;
  src?: string;
}

/* Handles the Responsiveness for Next/Image for 
any image without a defined height/width */
const ImageContainer = ({ src, alt, sizes = '' }: Props) => {
  return (
    src && (
      <div className="w-full">
        <Image
          src={src}
          alt={alt}
          fill
          sizes={sizes}
          className="!relative !h-[unset] !w-full object-contain"
        />
      </div>
    )
  );
};

export default ImageContainer;
